var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinterest = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6256_59907)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1037 15.635C15.7459 15.635 17.5383 13.176 17.5383 9.88453C17.5383 7.39636 15.4732 5.07812 12.3354 5.07812C8.43044 5.07812 6.46143 7.93621 6.46143 10.3195C6.46143 11.7626 6.99624 13.0465 8.14454 13.525C8.33267 13.6034 8.50124 13.5275 8.55602 13.315C8.59348 13.1677 8.68407 12.7961 8.72341 12.6416C8.77854 12.4311 8.75734 12.3574 8.60538 12.1739C8.2746 11.7749 8.0635 11.2593 8.0635 10.5283C8.0635 8.4081 9.61669 6.51005 12.1098 6.51005C14.3163 6.51005 15.5295 7.88642 15.5295 9.72542C15.5295 12.1446 14.4809 14.1863 12.9237 14.1863C12.0635 14.1863 11.4204 13.4604 11.6263 12.5703C11.8729 11.5074 12.3521 10.3599 12.3521 9.59266C12.3521 8.90622 11.9911 8.33294 11.2435 8.33294C10.3644 8.33294 9.65839 9.26158 9.65839 10.5049C9.65839 11.2969 9.92096 11.8326 9.92096 11.8326C9.92096 11.8326 9.02133 15.7234 8.86336 16.4045C8.72011 17.0248 8.69867 17.7065 8.71882 18.2827C8.77901 18.7996 9.27966 19.2205 9.71399 18.6535C10.0193 18.1552 10.3476 17.526 10.5175 16.8954C10.6188 16.5222 11.0959 14.5892 11.0959 14.5892C11.3818 15.1453 12.2164 15.635 13.1037 15.635Z",
    fill: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6256_59907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinterest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pinterest.e120b3109faf5a59d45e468a80d9b0c4.svg";